"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fontSizes = require("../../../styles/fontSizes");

var _attachThemeAttrs = _interopRequireDefault(require("../../../styles/helpers/attachThemeAttrs"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    border: 0;\n    padding: 0;\n    display: inline-block;\n    color: ", ";\n    font-size: ", ";\n    line-height: 1.5;\n    margin: 0 auto 0.5rem auto;\n    text-align: center;\n    box-sizing: border-box;\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledLabel = (0, _attachThemeAttrs["default"])(_styledComponents["default"].legend)(_templateObject(), function (props) {
  return props.palette.text.label;
}, _fontSizes.FONT_SIZE_TEXT_MEDIUM, function (props) {
  return props.variant === 'inverse' && "\n            color: ".concat(props.palette.isDark ? '#576574' : 'rgb(178,178,178)', "\n        ");
});
var _default = StyledLabel;
exports["default"] = _default;